import { useTranslation } from 'react-i18next';

const STEP_NUMS = ['01', '02', '03', '04'];

function ProcessSection() {
  const { t } = useTranslation();
  const steps = t('process.steps', { returnObjects: true });

  return (
    <section className="process container" id="process">
      <div className="section-label">
        <span>{t('sections.process')}</span>
        <span>04 / 05</span>
      </div>
      <div className="process-grid">
        {STEP_NUMS.map((num, index) => (
          <div className="process-step fade-in" key={num}>
            <span className="step-num">{num}</span>
            <div className="step-title">{steps[index].title}</div>
            <p className="step-desc">{steps[index].desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default ProcessSection;
